import getImpcOptions from '../api/get-impc-options';
import { hasAccess, ROLE_OPERATOR } from './access';
import authentication from '../api/auth/authentication';

const updateOptionsWithNewImpcs = async (partyCode, options, updateOptions) => {
  const newImpcOptions = await getImpcOptions(partyCode);
  updateOptions({ ...options, impc: newImpcOptions.impc });
};

export const loadImpc = async (operatorVar, options, updateOptions) => {
  if (hasAccess([ROLE_OPERATOR])) {
    const partyCode = await authentication();
    await updateOptionsWithNewImpcs(partyCode, options, updateOptions);
  } else if (operatorVar.value !== undefined) {
    await updateOptionsWithNewImpcs(operatorVar.value, options, updateOptions);
  }
};
